import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { ActionLogEntry, RollbackResponse } from '@tailorcast/shared-types';

interface ActionsParams {
  page?: number;
  limit?: number;
}

interface ActionsResponse {
  actions: ActionLogEntry[];
  total: number;
  page: number;
}

export function useActions(params: ActionsParams = {}) {
  const { page = 1, limit = 20 } = params;
  const url = `${COMMERCE.ACTION_HISTORY}?marketplace=bitrix&page=${page}&limit=${limit}`;

  return useQuery({
    queryKey: ['actions', params],
    queryFn: () => api.get<ActionsResponse>(url),
  });
}

export function useRollbackAction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (actionId: string) =>
      api.post<RollbackResponse>(COMMERCE.ACTION_ROLLBACK(actionId)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['actions'] });
    },
  });
}
